import { Box, Typography } from '@mui/material';
import { getUserSettings } from '@surfline/web-common';
import { getCamListScrollPosition } from 'selectors/animations';
import { getNearbySpots, getReverseSortBeachView } from 'selectors/spot';
import { useUserPermissionStatus } from 'selectors/user';
import { useAppSelector } from 'stores/hooks';
import type { CamListScrollPosition } from 'types/camera';
import type { SpotReportData } from 'types/spot';
import type { SurfHeight } from 'types/units';
import MotionScrollWrapper from '../MotionScrollWrapper';
import CamList from '../CamList';

import styles from './NearbySpots.module.scss';

interface Props {
  spotId: string;
}

const NearbySpots: React.FC<Props> = ({ spotId }) => {
  const nearbySpots: Array<SpotReportData> | undefined = useAppSelector(getNearbySpots);
  const reverseSortBeachView: boolean = useAppSelector(getReverseSortBeachView);
  const userSettings = useAppSelector(getUserSettings);
  const camListScrollPosition: CamListScrollPosition = useAppSelector(getCamListScrollPosition);
  const { hasPremiumCamPermissions } = useUserPermissionStatus();

  const hasNearbySpots = !!nearbySpots && nearbySpots.length > 0;

  if (!hasNearbySpots) {
    return null;
  }

  return (
    <div className={styles.nearbyCams}>
      <Box className={styles.headerContainer}>
        <Typography color="text.extraLight" variant="h2">
          Nearby Spots
        </Typography>
      </Box>
      {hasNearbySpots && (
        <div className="sl-section-full-bleed">
          <MotionScrollWrapper scrollPosition={camListScrollPosition}>
            <CamList
              spots={reverseSortBeachView ? [...nearbySpots].reverse() : nearbySpots}
              spotId={spotId}
              units={userSettings?.units.surfHeight as SurfHeight}
              hasPremiumCamPermissions={hasPremiumCamPermissions}
            />
          </MotionScrollWrapper>
        </div>
      )}
    </div>
  );
};

export default NearbySpots;
